<template>
  <div class="thread-comment">
    <div class="thread-comment__body">
      <div class="thread-comment__name">
        <div class="thread-comment__icon-wrapper">
          <span class="iconfont iprofile-icon"></span>
        </div>
        <span class="thread-comment__username">
          {{ comment.author.username }}
        </span>
        <span class="thread-comment__time"> {{ posted }} </span>
      </div>
      <span class="thread-comment__text">{{ comment.text }}</span>

      <div class="thread-comment__actions">
        <div class="thread-comment__reply-action">
          <span class="iconfont ireply-icon"></span>
          <a class="thread-comment__reply-text" @click.stop.prevent="showReply"
            >Reply
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Comment } from '@/models/interfaces'
import { calendar } from '@/helpers/time'

const props = defineProps<{
  comment: Comment
}>()

const emit = defineEmits(['replyShow'])

const posted = computed(() => {
  return calendar(props.comment.created)
})

const parentComment = computed(() => {
  if (props.comment.parent) {
    return props.comment.parent
  }
  return props.comment
})

function showReply(): void {
  emit('replyShow', parentComment.value)
}
</script>
